export default __webpack_public_path__ + "static/media/pg18-2.b6ad3add.png";